<template>
  <b-navbar-nav class="h-100">
    <!-- Categories & Subategories -->
    <li
      v-for="(cat, index) in categories"
      :key="index"
      class="nav-item veniqa-nav d-none d-lg-block"
      style="position: relative;"
      @mouseover="showCatSubMenu === index ? null : (showCatSubMenu = index)"
      @mouseleave="showCatSubMenu === index ? (showCatSubMenu = null) : null"  
    >
      <a
        target="_self" href="#" class="nav-link"
        :style="{ 
          borderBottom: showCatSubMenu === index ? '2px solid rgba(34, 34, 34, 0.7)' : '2px solid #fff',
          boxSizing: 'border-box',
        }"
      >
        {{ cat.name }}
      </a>
      <div
        v-show="showCatSubMenu === index"
        class="submenu"
      >
        <!-- Subcategories -->
        <ul class="subcategories">
          <li v-for="(subcat, sid) in cat.children" :key="sid">
            <a
              class="d-none d-lg-block"
              @click="openSubcategory(cat._id, subcat._id)"
            >{{subcat.name}}</a>
          </li>
        </ul>

        <!-- Links -->
        <ul class="cat-links">
          <li v-for="(link, lid) in cat.links" :key="lid">
            <a
              class="d-none d-lg-block"
              :href="link.url"
            >{{link.label}}</a>
          </li>
        </ul>
      </div>
    </li>

    <!-- Contact button -->
    <li
      class="nav-item veniqa-nav contact-btn"
      style="position: relative;"
    >
      <a class="nav-link" @click="gotoContact()">{{ $t('contact') }}</a>
    </li>
  </b-navbar-nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CategoriesNavbar',

  data() {
    return {
      showCatSubMenu: null,
    };
  },

  computed: {
    ...mapGetters({
      categories: 'categoryStore/categories',
    })
  },

  methods: {
    openSubcategory(categoryId, subcategoryId) {
      this.$router.push({
        path: '/search',
        query: {
          categoryId: categoryId,
          subcategoryId: subcategoryId
        },
      });
    },

    gotoContact() {
      this.$router.push('/contact');
    },
  }
};
</script>
